import { getEcho } from './echo'

import {
  EXPORT_PROGRESS_EVENT,
  getExportChannelName,
} from './socketEvents'

class ExportProgressSocket {
  constructor() {
    this.channel = null
    this.currentProgramId = null
  }

  subscribe(programId, handlers = {}) {
    if (!programId) {
      return
    }

    if (this.currentProgramId === programId) {
      return
    }

    this.unsubscribe()

    const echo = getEcho()

    if (!echo) {
      console.error('[ws] Echo is not initialized')
      return
    }

    const channelName = getExportChannelName(programId)

    console.log('[ws] subscribe:', channelName)

    this.channel = echo.private(channelName)

    this.channel.listen(
      EXPORT_PROGRESS_EVENT,
      (payload) => {
        if (handlers.onMessage) {
          handlers.onMessage(payload)
        }
      },
    )

    this.channel.error((error) => {
      console.error('[ws] channel error:', error)

      if (handlers.onError) {
        handlers.onError(error)
      }
    })

    this.currentProgramId = programId
  }

  unsubscribe() {
    if (!this.currentProgramId) {
      return
    }

    const echo = getEcho()

    if (!echo) {
      return
    }

    const channelName = getExportChannelName(this.currentProgramId)

    console.log('[ws] unsubscribe:', channelName)

    echo.leave(`private-${channelName}`)

    this.channel = null
    this.currentProgramId = null
  }
}

export default new ExportProgressSocket()
